import { ProductNameEnum } from '../../product-package-names';

export const ascendQuestAirflowWebQuestMetaId = 'ARWQ1613371749064';

export const getAirflowMetaId = (productEnum: string): string => {
  switch (productEnum) {
    case ProductNameEnum.AscendQuest:
      return ascendQuestAirflowWebQuestMetaId;
  }
  return '';
};

export const canEmbedLayout = true;
